<template>
	<v-card>
		<v-card-title>
			<h2>Oceny oferenta {{bidderName}}</h2>
		</v-card-title>

		<v-card-text>
			<v-layout row wrap align-center>
				<h2 class="ma-4 mr-5" style="text-align: center">Wyświetlaj:</h2>
				<v-flex xs2>
					<div class="mt-3 mr-2">
						<v-select
							style="display: inline"
							v-model="filter.type"
							aria-label="evaluations"
							:items="['Ostatnie oceny', 'Wszystkie oceny']"
						></v-select>
					</div>
				</v-flex>
				<v-btn @click="getEvaluationList" color="primary" dark class="ml-5">
					Wyświetl
				</v-btn>
				<!--				<v-spacer/>-->
				<v-btn @click="exportEvaluationList" color="primary" dark>
					Eksportuj
				</v-btn>
			</v-layout>
		</v-card-text>

		<v-data-table
			hide-actions
			:headers="headers"
			:items="evaluations"
			class="elevation-1">
			<template slot="items" slot-scope="props">
				<td>{{ props.item.evaluationDate }}</td>
				<td>{{ props.item.projectName }}</td>
				<td>{{ props.item.projectCode }}</td>
				<td>{{ props.item.realizationYear }}</td>
				<td>{{ props.item.accreditationCountry }}</td>
				<td>{{ props.item.evaluation }}</td>
				<td>
					<v-icon
						small class="mr-2"
						title="Podgląd"
						@click="viewBidderEvaluation(props.item.projectId, props.item.evaluationId)">
						description
					</v-icon>
					<v-icon
						small class="mr-2"
						:title="getArrearsTitle(props.item)"
						:color="getArrearsColor(props.item)"
						@click="showArrears(props.item.projectId)">
						account_balance_wallet
					</v-icon>
				</td>
			</template>
		</v-data-table>

		<ProjectArrearsView
			:is-open.sync="showArrearsData"
			:arrears-data="arrearsData"/>
	</v-card>
</template>

<script>
	import {BidderEvaluation} from "@/api/generated/BidderEvaluation";
	import {Bidder} from "@/api/generated/Bidder";
	import {Files} from "@/utils/Files";
	import {Project} from "@/api/generated/Project";
	import ProjectArrearsView from "../../../project/ProjectArrearsView";
  import {Filters} from "@/utils/Filters";

	export default {
		name: "BidderPersonalEvaluationsHistoryView",
		components: {ProjectArrearsView},

    mixins: [Filters],

		data () {
			return {
				bidderName: '',
				evaluations: [],
				filter: {
          type: 'Ostatnie oceny',
        },
				headers: [
					{text: "Data oceny", value: "evaluationDate", sortable: true},
					{text: "Nazwa projektu", value: "projectName", sortable: true},
					{text: "Numer projektu", value: "projectCode", sortable: true},
					{text: "Rok realizacji", value: "realizationYear", sortable: true},
					{text: "Kraj", value: "accreditationCountry", sortable: true},
					{text: "Ocena", value: "evaluation", sortable: true},
					{text: "Akcje", value: "actions", sortable: false},
				],
				showArrearsData: false,
				arrearsData: null,
			};
		},

		methods: {
			viewBidderEvaluation (projectId, evaluationId) {
				this.$router.push("/app/" + this.$route.params.id + "/" + projectId + "/evaluation-form/" + evaluationId);
			},

			refresh () {
        this.filter = this.retrieveFilters(this.filter);
				this.getBidderName();
				this.getEvaluationList();
			},

			getArrearsColor (evaluation) {
        if (!evaluation.assignedToArrears) {
          return "green darken-1";
        }
				switch (evaluation.projectArrearsStatus) {
					case "NONE":
						return "green darken-1";
					case "NOT_PAID":
						return "lightred";
					default:
						return "success";
				}
			},

			getArrearsTitle (evaluation) {
        if (!evaluation.assignedToArrears) {
          return "Brak zaległych płatności";
        }
				switch (evaluation.projectArrearsStatus) {
					case "NONE":
						return "Brak zaległych płatności";
					case "NOT_PAID":
						return "Zaległe płatności";
					default:
						return "Zaległe płatności uregulowane";
				}
			},

			showArrears (projectId) {
				Project.getArrears(this, projectId, successResponse => {
						this.arrearsData = successResponse;
						this.showArrearsData = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować zaległości projektu", errorResponse);
					});
			},

			exportEvaluationList () {
				BidderEvaluation.postExportPersonalEvaluations(this, this.$route.params.bidderId, this.filter.type === 'Ostatnie oceny', successResponse => {
						let filename = "eksport_ocen.xlsx";
						Files.methods.downloadBlobResponse(successResponse, filename);
						this.$messagesBus.$emit("success", "Eksport danych wykonano do pliku " + filename, successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Eksport nieudany", errorResponse);
					},
					{
						responseType: "blob",
					}
				);
			},

      getBidderName () {
        Bidder.getPolishName(this, this.$route.params.bidderId, successResponse => {
          this.bidderName = successResponse.name;
          },
            errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się załadować nazwy oferenta", errorResponse);
        });
        },

      getEvaluationList () {
        BidderEvaluation.getPersonalEvaluations(this, this.$route.params.bidderId, this.filter.type === 'Ostatnie oceny', successResponse => {
          this.evaluations = successResponse;
          },
            errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się załadować ocen oferenta", errorResponse);
        });
      }
		},

		created () {
			this.refresh();
		},
  };
</script>

<style scoped>

</style>
